<template>
  <div>
    <div id="container-97be7175d6f6c01520547c14bc780d33"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      originalSrc: '//evendisciplineseedlings.com/97be7175d6f6c01520547c14bc780d33/invoke.js'
    }
  },
  created () {
    // Delete all references included by adverts
    Object.keys(window)
      .filter(x => x.startsWith('_0x') && Array.isArray(window[x]) && window[x].length === 1)
      .forEach(x => delete window[x])
  },
  mounted () {
    // Re-imports advert script
    if (process.env.NODE_ENV === 'production') {
      setTimeout(() => {
        const script = document.createElement('script')
        script.setAttribute('src', `${this.originalSrc}?k=${Date.now()}`)
        document.head.appendChild(script)
      })
    }
  }
}
</script>
